<template>
    <div class="video-background">
    <div class="video-foreground">
      <video ref="test" controls
             src="../assets/sarikayasahinVideo.mp4"
             :width="width" :height="height" :videoWidth="width"  :videoHeight="height" autoplay muted />
    </div>

      <span class="videoOverlay"/>
  </div>
</template>

<script>
  export default {
  name: 'videoBg',
  data () {
    return {
        playerVars: {
            autoplay: 1,
            playlist: 'W0LHTWG-UmQ',
            loop: true,
            setLoop: true,
        }
        }
    },
    methods: {
     async playVideo() {
        try {
          await this.$refs.test.play();
        } catch(err) {
          console.log(err,'CANT PLAYED');
        }
      }
    },
    computed: {
      width: () => window.innerWidth,
      height: () => window.innerHeight
    },
   mounted() {

     console.log(this.$refs);
     this.playVideo()


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .video-background {
    background: #000;
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    z-index: -99;
    }
    .video-foreground,
    .video-background iframe {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    transform: scale(1.2);
    }
    .videoOverlay {
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 100;
    }
    @media only screen and (max-width: 780px){
      .videoOverlay {
        background: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        pointer-events: none;
        z-index: 100;
    }
      .video-background iframe {
        display: none;
      }
      .video-background {
        background: url(/static/sariKayasahinMobileBG.png) no-repeat no-repeat center center;
        background-size: cover;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: -99;
      }
    }
</style>



// WEBPACK FOOTER //
// videoBg.vue?bcec6322